<ul class="languages-switcher-list">
  <li class="languages-switcher-item" *ngFor="let lang of languages" (click)="onToggleLang(lang.key)">
    <img alt="flag" [src]="lang.imgUrl"> &#xA0;
    <span>{{ lang.title }}</span>
  </li>
</ul>
